import { Dialog, DialogType } from '../../../../src/feature/narrator/narrator.model';

export const dialog: Dialog[] = [
  {
    id: 'start',
    text: 'The building looks inviting, a place to rest from the road. A sign sways gently in the breeze, its creak adding to the cozy charm of the place.',
    type: DialogType.description,
    options: [
      {
        text: 'Enter',
        nextDialogId: 'tavern',
      },
    ],
  },
  {
    id: 'tavern',
    type: DialogType.description,
    text: 'You step inside, the warmth of the tavern enveloping you like a welcoming embrace. The scent of hearty food and spiced ale fills the air. At the bar, a young, pretty waitress catches your eye. She’s laughing lightly with a merchant, her eyes sparkling with a playful energy. Her smile seems to linger a little longer than necessary as she notices your gaze.',
    options: [
      {
        text: 'Listen in on their conversation.',
        nextDialogId: 'welcome',
      },
      {
        text: 'Catch the waitress’s attention.',
        nextDialogId: 'waitress_attention',
      },
    ],
  },
  {
    id: 'welcome',
    type: DialogType.dialog,
    text: 'The waitress leans closer to the merchant with a grin. "Two coins for a tallow candle? You would charge a drowning man for the rope, good merchant." The merchant only smiles into his cup. She is plainly enjoying herself.',
    options: [
      {
        text: 'Continue listening',
        nextDialogId: 'merchant_response',
      },
      {
        text: 'Get the attention of the waitress.',
        nextDialogId: 'waitress_attention',
      },
    ],
  },
  {
    id: 'merchant_response',
    type: DialogType.dialog,
    text: 'The merchant spreads his hands. "A man must live, girl. The roads are long, and the tolls on them longer still." He drains his cup and rises. The waitress tilts her head, then her gaze drifts toward you, lingering just a moment too long.',
    name: 'Merchant',
    options: [
      {
        text: 'Continue listening',
        nextDialogId: 'innkeeper_advice',
      },
      {
        text: 'Get the attention of the waitress.',
        nextDialogId: 'waitress_attention',
      },
    ],
  },
  {
    id: 'waitress_attention',
    type: DialogType.dialog,
    text: "The waitress notices you looking her way, a coy smile curling on her lips. She wipes a glass clean and saunters over with a playful twinkle in her eyes. 'Well, hello there, stranger. What brings you to my little corner of the world?' she asks, her tone teasing.",
    options: [
      {
        text: 'Ask for a drink.',
        nextDialogId: 'drink_order',
      },
      {
        text: 'Compliment her smile.',
        nextDialogId: 'flirty_exchange',
      },
      {
        text: 'Ask for a room',
        nextDialogId: 'stay_for_night',
      },
      {
        text: 'Flee',
        nextDialogId: 'flee',
      },
    ],
  },
  {
    id: 'flee',
    type: DialogType.dialog,
    text: 'You do not know how to react. You quickly grab your stuff',
    options: [
      {
        text: 'Leave the tavern',
        nextDialogId: 'start',
      },
    ],
  },
  {
    id: 'flirty_exchange',
    type: DialogType.dialog,
    text: 'Her smile widens as she hears your compliment. "Flattery will get you everywhere, traveler," she says, her voice low and playful. "But I warn you, I’m not so easily won over." She gives you a wink before turning to fetch your drink.',
    options: [
      {
        text: 'Continue the conversation.',
        nextDialogId: 'waitress_attention',
      },
      {
        text: 'Sit back and enjoy the atmosphere.',
        nextDialogId: 'end_dialog',
      },
    ],
  },
  {
    id: 'drink_order',
    type: DialogType.dialog,
    text: 'You order a drink, and she nods with a playful grin. "Coming right up. But don’t get too comfortable, I might just have other ways to keep you entertained," she teases before walking away.',
    options: [
      {
        text: 'Wait for your drink and enjoy the ambiance.',
        nextDialogId: 'end_dialog',
      },
      {
        text: 'Ask for a room',
        nextDialogId: 'stay_for_night',
      },
      {
        text: 'Look around the tavern for something else to do.',
        nextDialogId: 'end_dialog',
      },
    ],
  },
  {
    id: 'innkeeper_advice',
    type: DialogType.dialog,
    text: 'Listen more than you speak, traveller. The folk on the road carry news worth more than coin in days like these.',
    options: [
      {
        text: 'Thank you for the advice!',
        nextDialogId: 'end_dialog',
      },
    ],
  },
  {
    id: 'stay_for_night',
    text: "You lean in slightly, your voice casual but with a hint of interest. 'I’d like a room for the night.' The waitress's eyes sparkle as she flashes you a playful smile. 'Of course, traveler. You’ve made a wise choice. A warm bed, a hearty meal, and maybe a bit more, if you're lucky.' She gives you a lingering glance before adding, 'Make yourself at home, and I’ll see to your needs.' With that, you settle in, the comfort of the tavern surrounding you as you wonder what surprises tomorrow might bring.",
    type: DialogType.description,
    options: [
      {
        text: 'Sleep',
        nextDialogId: 'morning_wakeup',
      },
    ],
  },
  {
    id: 'morning_wakeup',
    type: DialogType.dialog,
    text: "The morning sun filters through the tavern's windows, casting warm, golden light across the room. You wake up feeling rested, the soft sound of birds chirping outside reminding you that a new day has begun. The tavern is quiet, save for the occasional clink of a mug from downstairs. You stretch and take a deep breath, the air fresh and filled with promise. The bed was comfortable, but the day ahead calls to you. You wonder what adventures await.",
    options: [
      {
        text: 'Get up and step out into the day.',
        nextDialogId: 'step_outside',
      },
      {
        text: 'Take a moment to enjoy the peaceful atmosphere.',
        nextDialogId: 'stay_for_now',
      },
    ],
  },
  {
    id: 'step_outside',
    type: DialogType.dialog,
    text: "You rise from the bed, stretch one last time, and make your way downstairs. The waitress looks up from behind the bar with a smile, her eyes twinkling as she watches you approach. 'Good morning, traveler,' she says with a teasing tone. 'I see you’re up early, ready to conquer the day?' As you step outside into the crisp morning air, you feel her gaze lingering on you for just a moment longer.",
    options: [
      {
        text: 'Step outside',
        nextDialogId: 'start',
      },
    ],
  },
  {
    id: 'stay_for_now',
    type: DialogType.dialog,
    text: "You take a few moments to savor the peaceful morning. The warmth of the tavern contrasts with the cool morning air outside. As you relax, you hear the soft click of footsteps approaching, and the waitress appears beside you with a playful grin. 'I thought you might need some company before you head out,' she says, her voice light and teasing. 'You’re not in a rush, are you?' You smile and sip your drink, enjoying the moment.",
    options: [
      {
        text: 'Now, it’s time to step outside and begin your day.',
        nextDialogId: 'step_outside',
      },
    ],
  },
  {
    id: 'end_dialog',
    text: 'The conversation fades, and you consider your next move.',
    options: [
      {
        text: 'Get the attention of the waitress.',
        nextDialogId: 'waitress_attention',
      },
    ],
    type: DialogType.description,
  },
];
